package com.sweetlime.bingeamigo.model

import kotlinx.serialization.Serializable

@Serializable
data class UserActivity(
    val id: String = "",
    val userId: String = "",
    val username: String = "",
    val userAvatar: String = "",
    val type: Int = 0,
    val movieId: Int = 0,
    val movieTitle: String = "",
    val moviePoster: String = "",
    val tvShowId: Int = 0,
    val tvShowTitle: String = "",
    val tvShowPoster: String = "",
    val seasonNumber: Int = 0,
    val episodeNumber: Int = 0,
    val episodeId: Int = 0,
    val episodeName: String = "",
    val episodeStillPath: String = "",
    val rating: Double = 0.0,
    val timestamp: Long = 0L
)